import { useState } from "react";
import { useReOS } from "../../domain/store";
import type { InventoryItem } from "../../domain/types";
import { moneyInputValue, parseMoneyInput } from "../../domain/money";
import { userSafeErrorMessage } from "../../lib/userSafeError";
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Field, Input } from "../ui/field";
import { Button } from "../ui/button";
import { useToast } from "../ui/toast";
import { Alert } from "../ui/alert";

export function InventoryTargetPriceDialog({ item, onClose }: { item: InventoryItem; onClose: () => void }) {
  const store = useReOS();
  const toast = useToast();
  const [value, setValue] = useState(item.targetPrice.amountMinor > 0 ? moneyInputValue(item.targetPrice) : "");
  const [expectedUpdatedAt] = useState(item.updatedAt);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  async function save() {
    const price = parseMoneyInput(value, item.targetPrice.currency);
    if (!value.trim() || !Number.isFinite(Number(value)) || !Number.isSafeInteger(price.amountMinor) || price.amountMinor <= 0) { setError("Enter a price greater than zero."); return; }
    setBusy(true); setError("");
    try { await store.updateInventoryItem(item.id, { targetPriceMinor: price.amountMinor, expectedUpdatedAt }); toast.notify({ title: "Target price saved", tone: "success" }); onClose(); }
    catch (caught) { setError(userSafeErrorMessage(caught, "Couldn’t save the target price. Try again.")); }
    finally { setBusy(false); }
  }
  return <Dialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}><DialogContent>
    <DialogHeader><DialogTitle>Edit target price</DialogTitle><DialogDescription>{item.title}</DialogDescription></DialogHeader>
    <form onSubmit={(event) => { event.preventDefault(); void save(); }}>
      <DialogBody>
      <Field label={`Target price (${item.targetPrice.currency})`}><Input autoFocus type="number" min="0.01" step="0.01" inputMode="decimal" required disabled={busy} value={value} onChange={(event) => setValue(event.target.value)} /></Field>
      <p className="inventory-target-hint">New listing drafts start here. Existing listing prices stay as they are.</p>
      {error && <Alert tone="danger">{error}</Alert>}
      </DialogBody>
      <DialogFooter><Button variant="ghost" type="button" disabled={busy} onClick={onClose}>Cancel</Button><Button variant="primary" type="submit" loading={busy} loadingLabel="Saving price">Save price</Button></DialogFooter>
    </form>
  </DialogContent></Dialog>;
}
